import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { PuiMenuComponent } from './menu.component';

@Component({
    selector: 'pui-menu-profile',
    templateUrl: 'menu-profile.component.html'
})

export class PuiMenuProfileComponent implements AfterContentInit {
    @ContentChildren(PuiMenuComponent) menus: QueryList<PuiMenuComponent>;

    constructor() { }

    ngAfterContentInit() {
        // console.log(this.menus.length);
    }
}
